import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AdminUserModel} from '../../../../api/model/Admin-user.model';

@Component({
  selector: 'tj-admin-edit-form',
  templateUrl: './admin-edit-form.component.html',
  styleUrls: ['./admin-edit-form.component.scss']
})
export class AdminEditFormComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  userForm: FormGroup;

  @Input() set isCreateMode(value: boolean) {
    if (this._isCreateMode !== value) {
      this._isCreateMode = value;
      if (this.userForm) {
        this.userForm.reset();
      }
      this.initForm();
    }
  }

  get isCreateMode(): boolean {
    return this._isCreateMode;
  }

  private _isCreateMode = true;

  @Input() set admin(value: AdminUserModel | null) {
    if (value && this.userForm) {
      this.userForm.patchValue({
        firstName: value.firstName || '',
        lastName: value.lastName || '',
        email: value.email || '',
        active: value.active || false,
      });
    }
  }

  @Output() save = new EventEmitter<Partial<AdminUserModel>>();
  @Output() cancel = new EventEmitter<void>();

  ngOnInit(): void {
    if (!this.userForm) {
      this.initForm();
    }
  }

  private initForm(): void {
    const groupConfig: any = {
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    };

    if (this.isCreateMode) {
      groupConfig.username = ['', Validators.required];
      groupConfig.password = ['', Validators.required];
    } else {
      groupConfig.active = [true];
    }

    this.userForm = this.fb.group(groupConfig);
  }

  onSubmit(): void {
    if (this.userForm.valid) {
      const {firstName, lastName, email, active, username, password} = this.userForm.value;
      this.save.emit({
        firstName,
        lastName,
        email,
        ...(!this.isCreateMode && {active}),
        ...(this.isCreateMode && {username, password}),
      });
    }
  }

  onCancel(): void {
    this.userForm.reset();
    this.cancel.emit();
  }

  isFieldInvalid(field: string): boolean {
    const control = this.userForm.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}
